import { __assign } from "tslib";
import EventEmitter from 'mitt';
import { Events } from './config';
export var emitter = new EventEmitter();
var toast = function (options) {
    if (options === void 0) { options = {}; }
    if (!options.message) {
        throw new Error('Molekule: Toast requires a message');
    }
    emitter.emit(Events.ADD, options);
};
toast.success = function (message, options) {
    if (options === void 0) { options = {}; }
    toast(__assign({ message: message, type: 'success' }, options));
};
toast.error = function (message, options) {
    if (options === void 0) { options = {}; }
    toast(__assign({ message: message, type: 'error' }, options));
};
toast.warn = function (message, options) {
    if (options === void 0) { options = {}; }
    toast(__assign({ message: message, type: 'warn' }, options));
};
toast.info = function (message, options) {
    if (options === void 0) { options = {}; }
    toast(__assign({ message: message, type: 'info' }, options));
};
export default toast;
//# sourceMappingURL=toast.js.map